/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetDistrictRegionsAdminResponse } from '../models/GetDistrictRegionsAdminResponse';
import type { GetDistrictsByRegionAdminResponse } from '../models/GetDistrictsByRegionAdminResponse';
import type { GetDistrictsByRegionOperatorResponse } from '../models/GetDistrictsByRegionOperatorResponse';
import type { PostDistrictsDisabilityAdminRequest } from '../models/PostDistrictsDisabilityAdminRequest';
import type { PostRegionDistrictsAdminRequest } from '../models/PostRegionDistrictsAdminRequest';
import type { PostRegionDistrictsAdminResponse } from '../models/PostRegionDistrictsAdminResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DistrictsService {
    /**
     * @returns GetDistrictsByRegionOperatorResponse OK
     * @throws ApiError
     */
    public static getDistrictsByRegionOperator({
        regionId,
    }: {
        regionId: number,
    }): CancelablePromise<GetDistrictsByRegionOperatorResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/districts/regions/{regionId}',
            path: {
                'regionId': regionId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDistricts`
     * @returns PostRegionDistrictsAdminResponse OK
     * @throws ApiError
     */
    public static postDistrictsByRegionAdmin({
        requestBody,
    }: {
        requestBody?: PostRegionDistrictsAdminRequest,
    }): CancelablePromise<PostRegionDistrictsAdminResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/districts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDistricts`
     * @returns GetDistrictsByRegionAdminResponse OK
     * @throws ApiError
     */
    public static getDistrictsByRegionAdmin({
        regionId,
    }: {
        regionId: number,
    }): CancelablePromise<GetDistrictsByRegionAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/districts/regions/{regionId}',
            path: {
                'regionId': regionId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDistricts`
     * @returns GetDistrictRegionsAdminResponse OK
     * @throws ApiError
     */
    public static getRegionDistrictsAdmin(): CancelablePromise<GetDistrictRegionsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/districts/regions',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteDistricts`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteDistrictAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/districts/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDistricts`
     * @returns any OK
     * @throws ApiError
     */
    public static putDistrictDisabilityAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PostDistrictsDisabilityAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/districts/{id}/disability',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
